'use client';

import { useEffect, useState } from 'react';

export type TocSection = {
  id: string;
  label: string;
};

type TableOfContentsProps = {
  sections: TocSection[];
};

export default function TableOfContents({ sections }: TableOfContentsProps) {
  const [activeId, setActiveId] = useState<string>(sections[0]?.id ?? '');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      {
        rootMargin: '-40% 0px -40% 0px',
        threshold: 0,
      }
    );

    sections.forEach((section) => {
      const el = document.getElementById(section.id);
      if (el) {
        observer.observe(el);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [sections]);

  if (!sections.length) {
    return null;
  }

  return (
    <nav className="toc">
      <p className="toc__label">On this page</p>
      <ul>
        {sections.map((section) => (
          <li key={section.id} className={section.id === activeId ? 'active' : undefined}>
            <a href={`#${section.id}`}>{section.label}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
